angular
  .module 'bookAndPay'
  .factory 'BookAndPayService', (
    $http,
    DataService,
    flash,
    $timeout
  ) ->
    isExpired: (cart, withRedirect) ->
      if cart.expired_by_system_time
        return true

      if moment(cart.expires_at).isBefore(moment())
        cart.expired_by_system_time = true
        @expireCart(cart, withRedirect)
        true

    expireCart: (cart, withRedirect) ->
      url = "/websites/#{DataService.domain}/book_and_pay/carts/#{cart.cart_uuid}/expire_cart"
      $http.put(url).then (response) ->
        if withRedirect
          flash.error = response.data.message || "Your cart has expired."
          $timeout ->
            window.location.href = response.data.redirect_url
          , 2000
